import React from 'react';
import useRunOnce from '$/hooks/useRunOnce';
import { pad00 } from './string';

import { tzNames } from '$/shared/frontend/utils/tzNames';
import { getTimezoneOffset } from 'date-fns-tz';

export enum TimeZoneOption {
  OfAttendee = "Attendee's local time zone",
  Fixed = 'Fixed time zone',
}

export const timeZoneOfAttendee = 'client';

export interface TZOption {
  key: string;
  value: string;
  text: string;
}

export function useTimezones(): TZOption[] {
  const [timezones, setTimezones] = React.useState<TZOption[]>([]);

  useRunOnce(() => {
    const now = new Date();

    setTimezones(
      Object.keys(tzNames)
        .map((k) => {
          const offset = getTimezoneOffset(tzNames[k], now) / 60000;

          return {
            value: tzNames[k],
            text: `${k} ${offset > 0 ? '+' : ''}${Math.floor(offset / 60)}:${pad00(
              Math.abs(offset) % 60
            )}`,
            offset: offset,
            key: k,
          };
        })
        .sort((a, b) => a.offset - b.offset)
    );
  });

  return timezones;
}

export const isValidTimeZone = (tzNames: string): boolean => {
  if (!Intl || !Intl.DateTimeFormat().resolvedOptions().timeZone) {
    return false;
  }
  try {
    Intl.DateTimeFormat(undefined, { timeZone: tzNames });
    return true;
  } catch (ex) {
    return false;
  }
};

export const getCityByTimezone = (timezone: string): string | undefined => {
  const city = (tzNames as Record<string, string>)[timezone];
  if (!city) return undefined;

  const parts = /(?:.*\s-)?(.*)\s*[-+][\d:]+$/.exec(city.trim());
  if (parts && parts.length > 1) {
    return parts[1];
  }
  return undefined;
};
